import local from "./configs/local";
import integration from "./configs/integration";
import prod from "./configs/prod";

export type EnvConfig = {
  basketBFFBaseUrl: string;
  socialProofApi: string;
  onlineStockBaseUrl: string;
  onlineStockApiKey: string;
  hostUrl: string;
};

const clientEnvironment =
  typeof window !== "undefined"
    ? window.origin.includes("integration.project4.com")
      ? "integration"
      : window.origin.includes("johnlewis.com")
        ? "prod"
        : undefined
    : undefined;
const serverEnvironment =
  typeof process !== "undefined" ? process.env["ENVIRONMENT"] : undefined;

const environment = clientEnvironment || serverEnvironment;
const config =
  environment === "prod"
    ? prod
    : environment === "integration"
      ? integration
      : local;

export default config;
